<template>
  <div class="scroll_flex_container px-6">
    <navbar title="分享拿好禮"></navbar>
    <div class="scroll_flex_container">
      <img src="@/assets/share-event.png" class="w-full h-[236px] mb-4 object-contain" />
      <text class="w-full text-base column_start_start flex-wrap"
        style="letter-spacing: 0.64px;">點選複製或LINE分享會員專屬網址，邀請朋友加入「Bryant咖啡館」會員。</text>
      <text class="w-full text-base column_start_start flex-wrap" style="letter-spacing: 0.64px;">
        加入成功即可取得店家提供的邀請禮喔！</text>
      <div class="column_center_start w-full mt-4">
        <text class="text-lg font-semibold">分享網址</text>
        <div class="row_center_start w-full mt-2">
          <div class="flex-grow h-[46px] row_center_center bg-[#00000014]  px-4 truncate">
            <text class="w-full text-base text-left truncate">https://share.okshop.tw/</text>
          </div>
          <img class="share_button mx-1.5 shrink-0" src="@/assets/share-btnLink.png" @click="copyLink" />
          <img class="share_button shrink-0" src="@/assets/share-btnLine.png" @click="shareToLine" />
        </div>
      </div>
      <text class="w-full row_center_start text-xs font-semibold text-[#666666] mt-4 mb-2">您自己可獲得</text>
      <img src="@/assets/meeting_gift.png" class="w-full object-contain h-[118px]">
      <text class="w-full row_center_start text-xs font-semibold text-[#666666] mt-4 mb-2">新朋友可獲得</text>
      <img src="@/assets/meeting_gift.png" class="w-full object-contain h-[118px]">
    </div>
  </div>
</template>
<script>
import navbar from "@/components/general/navbar.vue";
import commonUtils from "@/utils/common.utils";
export default {
  components: {
    navbar
  },
  methods: {
    copyLink() {
      const shareUrl = 'https://share.okshop.tw/'
      // 複製連結到剪貼簿
      const cb = navigator.clipboard;
      cb.writeText(shareUrl);
      commonUtils.createToast('success', '複製分享網址成功')

    },
    shareToLine() {
      const shareUrl = 'https://share.okshop.tw/'
      window.open(`line://msg/text/${encodeURIComponent(shareUrl)}`, '_blank', "popup");
    }
  },
};
</script>
<style lang="scss">
.eventImg {
  width: 100%;
  height: 236px;
  margin-bottom: 16px;
}
</style>
